export default function PaymentDetailPage() {
  return null;
}
